import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
// import { howVarahiSoftWorks } from '../../common';
import axios from 'axios';
// import { HashLink as Link } from 'react-router-hash-link';
// import techImg from '../../assets/images/landingpage/smiling-executives-waiting-meeting.png'

const WhyHow = () => {
    const [whyVarahiSoft, setData] = useState({});
    const [howVarahiSoftWorks, setHowVarahiSoftWorks] = useState({});

    const getAllWhyVarahiSoftData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/whyVarahiSoft.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllHowVarahiSoftWorksData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/howVarahiSoftWorks.json');
            setHowVarahiSoftWorks(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getAllWhyVarahiSoftData()
        getAllHowVarahiSoftWorksData()
    }, [])


    return (
        <section className='why-how-component'>
            <div className='tech-content'>
                <Container className="">
                    <div className='custom-padding d-flex align-items-center justify-content-between gap-4'>
                        <div className='w-100'>
                            <h4>{whyVarahiSoft?.title}</h4>
                            {whyVarahiSoft?.paragraph?.map((item, i) => <p key={i}>{item?.text}</p>)}
                        </div>
                        <div className='pe-5'>
                            <div className='pe-5'>
                                <h4>{howVarahiSoftWorks?.title}</h4>
                                <ul>
                                    {howVarahiSoftWorks?.worksData?.map((workData, index) => <li key={index}><p>{workData?.text}</p></li>)}
                                </ul>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </section>
    );
}

export default WhyHow;
